const CreditCardPaymentPolicy =[
  // this defines the credit card levels, and eligibility rqmts for each level
  {paymentPolicyCode: "manualPay", desc: "The credit card bill is paid manually each month."},
  {paymentPolicyCode: "autoPayMin", desc: "The minimum payment amount is paid automatically each month."},
  {paymentPolicyCode: "autoPayFull", desc: "The outstanding credit card balance is paid automatically each month."}

];

export default CreditCardPaymentPolicy;